import * as React from 'react'
function SvgMinus(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M4 16h32v8H4z" fill="currentColor" fillRule="evenodd" />
		</svg>
	)
}
export default SvgMinus
